import { render } from "./Figure.vue?vue&type=template&id=65487eb5&scoped=true"
import script from "./Figure.vue?vue&type=script&lang=js"
export * from "./Figure.vue?vue&type=script&lang=js"

import "./Figure.vue?vue&type=style&index=0&id=65487eb5&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src236468918/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65487eb5"]])

export default __exports__